import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import configureStore from './configureStore';

import './App.css';

import { Common } from './components';

import Home from './pages/Home';
import CheckDeviceNoCamera from './pages/CheckDeviceNoCamera';

import ApplicationOTP from './pages/ApplicationOTP';
import ApplicationOTPSuccess from './pages/ApplicationOTPSuccess';

import ApplicationConsent from './pages/ApplicationConsent';
import ApplicationForm1 from './pages/ApplicationForm1';
import ApplicationForm21 from './pages/ApplicationForm21';
import ApplicationForm22 from './pages/ApplicationForm22';
import ApplicationConfirmData from './pages/ApplicationConfirmData';
import ApplicationIdCheck from './pages/ApplicationIdCheck';
import ApplicationIdCheckResult from './pages/ApplicationIdCheckResult';
import ApplicationSelfieCheck from './pages/ApplicationSelfieCheck';
import ApplicationSelfieCheckResult from './pages/ApplicationSelfieCheckResult';
import ApplicationComplete from './pages/ApplicationComplete';

import CheckLoanStatusOTP from './pages/CheckLoanStatusOTP';
import CheckLoanStatusConsent from './pages/CheckLoanStatusConsent';
import CheckLoanStatusStage from './pages/CheckLoanStatusStage';

import ConfirmSelfieCheck from './pages/ConfirmSelfieCheck';
import ConfirmSelfieCheckResult from './pages/ConfirmSelfieCheckResult';
import ConfirmEsignCheck from './pages/ConfirmEsignCheck';
import { useEffect } from 'react';
import { detectMob, onTokenExpired } from './utils/common'
import ConfirmIdCheck from './pages/ConfirmIdCheck';
import ConfirmIdCheckResult from './pages/ConfirmIdCheckResult';
import ConfirmApplicationComplete from './pages/ConfirmApplicationComplete';
import ApplicationIdCheckDalite from './pages/ApplicationIdCheckDalite';
import ConfirmIdCheckDalite from './pages/ConfirmIdCheckDalite';
import ApplicationEkycConfirm from './pages/ApplicationEkycConfirm';
import MoneyHero from './pages/MoneyHero';
import LendelaVerify from './pages/LendelaVerify';
import QuickCashOTP from './pages/QuickCash20000/OTP';
import QuickCashOTPSuccess from './pages/QuickCash20000/OTPSuccess';
import QuickCashConsent from './pages/QuickCash20000/Consent';
import QuickCashForm from './pages/QuickCash20000/Form';
import QuickCashConfirm from './pages/QuickCash20000/Confirm';
import QuickCashComplete from './pages/QuickCash20000/Complete';
import { QUICK_CASH_ROUTES } from './pages/QuickCash20000/routes';
import {
  getQuickCashDesktopRedirectUrl,
  isLocalHostname,
} from './utils/quickCashDesktopRedirect';

function App() {
  const store = configureStore();
  // check expired token
  useEffect(() => {
    onTokenExpired();

    const excludePaths = ['check-loan', 'money-hero', 'no-doc-loan', 'check_status'
      , 'application-desktop'];//local 일경우....
    const pathname = window.location.pathname;
    const isExcluded = excludePaths.some(path => pathname.includes(path));
    // 로컬에서는 PC 브라우저로도 신청 화면을 확인할 수 있도록 데스크톱 리다이렉트를 생략한다.
    const isLocal = isLocalHostname(window.location.hostname);

    if (!detectMob() && !isExcluded && !isLocal) {
      console.log('redirect is desktop');
      const open = new URLSearchParams(window.location.search).get('open');

      // Quick Cash PC 요청인 경우에만 환경별 전용 안내 페이지와 open 쿼리를 사용한다.
      const quickCashDesktopRedirectUrl = getQuickCashDesktopRedirectUrl(
        window.location.search,
        process.env.REACT_APP_QUICK_CASH_DESKTOP_URL
      );

      // 신청 상태 확인과 Quick Cash만 전용 안내 페이지로 보내고, 나머지는 기존 PC 리다이렉트를 유지한다.
      window.location.href = open === 'check_status'
        ? `${process.env.REACT_APP_HOME_URL}/check-status-desktop/`
        : quickCashDesktopRedirectUrl
          || `${process.env.REACT_APP_HOME_URL}/application-desktop/`;
    }
  }, []);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <div className={`App ${['money-hero', 'no-doc-loan'].some(path => window.location.pathname.includes(path)) ? 'MoneyHero' : ''}`}>
          <Common.AppHeader />
          <Routes>
            <Route path="/" exact element={<Home />} />
            {/* <Route path="/" exact element={<ApplicationIdCheck />} /> */}
            <Route path="/check-device-no-camera" element={<CheckDeviceNoCamera />} />

            <Route path="/application-otp" element={<ApplicationOTP />} />
            <Route path="/application-otp-success" element={<ApplicationOTPSuccess />} />
            <Route path="/application-consent" element={<ApplicationConsent />} />
            <Route path="/application-form-1" element={<ApplicationForm1 />} />
            <Route path="/application-form-2-1" element={<ApplicationForm21 />} />
            <Route path="/application-form-2-2" element={<ApplicationForm22 />} />
            <Route path="/application-confirm-data" element={<ApplicationConfirmData />} />
            <Route path="/application-ekyc-confirm" element={<ApplicationEkycConfirm />} />
            <Route path="/application-id-check" element={<ApplicationIdCheck />} />
            <Route path="/application-id-check/hkid" element={<ApplicationIdCheckDalite />} />
            <Route path="/application-id-check-result" element={<ApplicationIdCheckResult />} />
            <Route path="/application-selfie-check" element={<ApplicationSelfieCheck />} />
            <Route path="/application-selfie-check-result" element={<ApplicationSelfieCheckResult />} />
            <Route path="/application-complete" element={<ApplicationComplete />} />

            {/* 기존 신청 경로와 충돌하지 않는 Quick Cash 전용 라우트 */}
            <Route path={QUICK_CASH_ROUTES.otp} element={<QuickCashOTP />} />
            <Route path={QUICK_CASH_ROUTES.otpSuccess} element={<QuickCashOTPSuccess />} />
            <Route path={QUICK_CASH_ROUTES.consent} element={<QuickCashConsent />} />
            <Route path={QUICK_CASH_ROUTES.form} element={<QuickCashForm />} />
            <Route path={QUICK_CASH_ROUTES.confirm} element={<QuickCashConfirm />} />
            <Route path={QUICK_CASH_ROUTES.complete} element={<QuickCashComplete />} />

            <Route path="/check-loan-status-otp" element={<CheckLoanStatusOTP />} />
            <Route path="/check-loan-status-consent" element={<CheckLoanStatusConsent />} />
            <Route path="/check-loan-status-stage" element={<CheckLoanStatusStage />} />

            <Route path="/application/confirm/:token/confirm-id-check" element={<ConfirmIdCheck />} />
            <Route path="/application/confirm/:token/confirm-id-check/hkid" element={<ConfirmIdCheckDalite />} />
            <Route path="/application/confirm/:token/confirm-id-check-result" element={<ConfirmIdCheckResult />} />
            <Route path="/application/confirm/:token" element={<ConfirmSelfieCheck />} />
            <Route path="/application/confirm/:token/confirm-selfie-check-result" element={<ConfirmSelfieCheckResult />} />
            <Route path="/application/confirm/:token/confirm-esign-check" element={<ConfirmEsignCheck />} />
            <Route path="/application/confirm/complete" element={<ConfirmApplicationComplete />} />
            
            <Route path="/application/lendela/:token" element={<LendelaVerify />} />

            <Route path="/money-hero" element={<MoneyHero page='money-hero' />} />
            <Route path="/no-doc-loan" element={<MoneyHero page='no-doc-loan' />} />
          </Routes>
          <Common.AppFooter />
        </div>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
